<template lang="pug">
  div
    v-card.py-3(data-v-step='TourOrderListView-3' tile flat @click="openOrderItemDetailsDialog = true")
      v-row.mb-3(no-gutters align="center")
        v-col.px-4.shrink
          y-checkbox.mb-n3.mr-n2(v-model="checkbox" style="height:30px")
        v-col
          div.p2.basic600--text # {{ lead.rid }} {{ (lead.processed_at || lead.created) | convertServerDate }}
        v-col.px-4.shrink(v-if="view !== 'kanban'")
          v-chip.button-AA-tiny.text-uppercase(v-if="!isReady" data-v-step='TourOrderListView-4' x-small color="info400" style="height: 20px; border-radius: 10px;" dark) {{ $t('processing') }}
          v-chip.button-AA-tiny.text-uppercase(v-else data-v-step='TourOrderListView-4' x-small color="success400" style="height: 20px; border-radius: 10px;" dark) {{ $t('ready') }}
      div.px-4
        div.d-flex.align-center(v-if="details.customerName || details.source")
          template(v-if="details.customerName")
            div.s2.info500--text.mb-1 {{ ((lead.shipping_address && lead.shipping_address.name) || lead.name) }}
            v-spacer
          div.c1.basic600--text.mb-1(v-if="details.source") {{ lead.form.type === 'store' ? 'Yezza Store' : lead.form.name }}

        div.p2.basic700--text.mb-1(v-if="details.customerPhone") {{ ((lead.shipping_address && lead.shipping_address.phone) || lead.phone) | phoneFormat }}
        
        div.p2.basic700--text.mb-1(v-if="details.customerEmail && lead.email") {{ lead.email }}

        .customer-selection(v-if="details.shippingMethod || details.scheduledDateTime || details.address")
          div.c1.basic600--text.mb-1 {{ $t('customer_selection') }}:
          div.d-flex.align-center.mb-1(v-if="details.shippingMethod && lead.shipping")
            eva-icon.mb-n1.mr-1(name="car-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="15" height="15")
            div.p2.basic700--text(v-if="lead.pickup") {{ $t('self_pickup') }}
            div.p2.basic700--text(v-else) {{ lead.shipping.shipping_method | shippingMethodDisplay }}
            template(v-if="isArranged || isMatching || isFailed || lead.cod || lead.pay_at_shop")
              v-spacer
              v-chip.button-AA-tiny.text-uppercase(v-if="isArranged" x-small outlined color="success400" style="height: 20px; border-radius: 10px;" :style="`background-color: ${$vuetify.theme.themes[$theme].successT08} !important;`") {{ $t('arranged') }}
              v-chip.button-AA-tiny.text-uppercase(v-else-if="isFailed" x-small color="danger400" :style="`height: 20px; border-radius: 10px; background-color: ${$vuetify.theme.themes[$theme].dangerT08} !important`" outlined) {{ $t('failed') }}
              v-chip.button-AA-tiny.text-uppercase(v-else-if="isMatching" x-small color="info400" :style="`height: 20px; border-radius: 10px; background-color: ${$vuetify.theme.themes[$theme].infoT08} !important`" outlined) {{ $t('matching') }}
              template(v-else)
                v-chip.button-AA-tiny.text-uppercase(v-if="lead.cod" x-small dark color="primary" style="height: 20px; border-radius: 10px;") {{ $t('cod') }}
                v-chip.button-AA-tiny.text-uppercase(v-if="lead.pay_at_shop" x-small dark color="primary" style="height: 20px; border-radius: 10px;") {{ $t('pay_at_shop') }}

          div.d-flex.align-center.mb-1(v-if="details.scheduledDateTime && (lead.asking_delivery_date || lead.asking_delivery_time)")
            eva-icon.mb-n1.mr-1(name="clock-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="15" height="15")
            div.p2.basic700--text(v-if="lead.asking_delivery_date") {{ lead.asking_delivery_date | displayDate }}
              span.ml-1(v-if="lead.asking_delivery_time") at {{ lead.asking_delivery_time | displayTime }}

          v-row.mb-1(no-gutters v-if="details.address && lead.shipping_address && !lead.pickup")
            v-col.shrink.pr-1
              eva-icon.mb-n1(name="pin-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="15" height="15")
            v-col.pr-6(cols="10")
              div.p2.basic700--text(style="margin-top: 1px;") {{ lead.shipping_address.address_1 }},{{ lead.shipping_address.address_2 ? ` ${lead.shipping_address.address_2},` : '' }} {{ lead.shipping_address.postcode }},{{ lead.shipping_address.area ? ` ${lead.shipping_address.area}, ${lead.shipping_address.suburb},` : '' }} {{ lead.shipping_address.city }}, {{ lead.shipping_address.state }}, {{ lead.shipping_address.country }}.

          div.d-flex.align-center.mb-1(v-if="details.paymentMethod && lead.order_remarks && lead.order_remarks.payment_method")
            eva-icon.mb-n1.mr-1(name="credit-card-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="15" height="15")
            div.p2.basic700--text {{ lead.order_remarks.payment_method.display_name }}
        
        div.d-flex.mt-4.mb-2(v-if="details.amountPaid && lead.products.length > 0")
          div.c1.basic700--text {{ itemQuantity > 1 ? itemQuantity + ' items' : itemQuantity + ' item'  }}
          div.c1.basic700--text.ml-4 {{ lead.products.reduce((sum, p) => { return sum + (p.price_per_set * p.quantity) }, 0) | displayPrice }} {{ !lead.paid ? 'unpaid' : '' }}
        
        template(v-if="details.itemsOrdered && lead.products.length > 0")
          v-divider.basic300.mb-2
          div(v-for="(p, index) in lead.products")
            div.d-flex(:key="p.id" :class="index + 1 === lead.products.length ? 'mb-2' : 'mb-1'")
              div.c1.primary500--text {{ p.quantity }} x
              div.ml-3
                div.c2.primary500--text {{ getName(p) }}
                //- VARIANT NAME
                template(v-if="p.product.variant_for && checkParentVariantName(p)")
                  div.c1.primary400--text {{ p.product.name }}
                //- ADDON LIST
                template(v-if="p.addons.length > 0")
                  div(v-for="(a, idx) in p.addons" :key="'addon-' + idx")
                    div.c1.primary400--text.mr-1 + {{ a.name }}{{ a.quantity_per_set > 1 ? ' x ' + a.quantity_per_set : '' }}
                //- BUNDLE LIST
                template(v-if="p.bundles.length > 0")
                  div(v-for="(b, idx) in p.bundles" :key="'bundle-' + idx")
                    div.c1.primary400--text.mr-1 {{ idx + 1 }}. {{ b.name }}
                    //- BUNDLE PRODUCT NOTES
                    div(v-if="b.product_notes_data && b.product_notes_data.length > 0")
                      div(v-for="note in b.product_notes_data" :key="note.id")
                        div.c1.primary400--text.ml-1 - 
                          strong {{ note.name }}: 
                          | {{ note.data }}
                //- PRODUCT NOTES
                div.mt-1(v-if="p.product_notes_data && p.product_notes_data.length > 0")
                  div(v-for="note in p.product_notes_data" :key="note.id")
                    div.c1.primary400--text
                      strong {{ note.name }}: 
                      | {{ note.data }}
              v-spacer
              div
                div.c1.primary400--text {{ p.price_per_set * p.quantity | displayPrice }}
        
        template(v-if="details.orderMessage && lead.order_remarks && lead.order_remarks.order_message")
          v-divider.basic300.mb-2
          div.c1.basic600--text.mb-2 {{ $t('message') }}: {{ lead.order_remarks.order_message }}

        template(v-if="details.remarks && lead.remarks")
          v-divider.basic300.mb-2
          div.c1.basic600--text.mb-2 {{ $t('remarks') }}: {{ lead.remarks }}

        template(v-if="details.extraInfo && lead.extra_fields_data && lead.extra_fields_data.length > 0")
          v-divider.basic300.mb-2
          div.c1.primary--text.mb-1(v-for="field in lead.extra_fields_data" style="white-space: pre-wrap;") {{ field.name }}: {{ field.value }}

    .modals
      order-item-details(v-if="openOrderItemDetailsDialog" :open.sync="openOrderItemDetailsDialog" :parentLead.sync="lead" @deleted="$emit('deleted', $event)")
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import OrderItemDetails from '@/components/dialogs/order/OrderItemDetails.vue'

export default {
  name: 'OrderItem',
  props: ['parentLead', 'menu', 'checkboxActiveExport', 'checkboxActiveShipping'],
  components: { OrderItemDetails },
  data: () => ({
    openOrderItemDetailsDialog: false,
    setTimeOutTooltip: null,
  }),
  computed: {
    ...mapState('user', ['member']),
    ...mapGetters({
      details: 'orders/getOrderDetails',
      view: 'orders/getOrderView',
      selectedLeads: 'orders/getSelectedLeads'
    }),
    lead: {
      get() {
        return this.parentLead
      },
      set(newValue) {
        this.$emit('edited', newValue)
      }
    },
    isReady () {
      if (this.lead.taggings.filter(f => f.tagging === 'ready').length > 0) {
        return true
      }
      return false
    },
    isArranged () {
      if (this.lead.taggings.filter(f => f.tagging === 'arranged').length > 0) {
        return true
      }
      return false
    },
    isFailed () {
      return this.lead.taggings[0] ? this.lead.taggings[0].tagging === 'failed' : false
    },
    isMatching () {
      return this.lead.taggings[0] ? this.lead.taggings[0].tagging === 'matching' : false
    },
    itemQuantity () {
      if (this.lead && this.lead.products.length > 0) {
        return this.lead.products.reduce((sum, p) => { return sum + (p.quantity) }, 0)
      }
      return 0
    },
    checkbox: {
      get () {
        if (this.selectedLeads.filter(f => f.id === this.lead.id)[0]) {
          return true
        }
        return false
      },
      set (val) {
        if (val) {
          this.$store.commit('orders/addLead', this.lead)
        } else {
          this.$store.commit('orders/deleteLead', this.lead)
        }
      }
    },
  },
  methods: {
    getName (product) {
      if (product.product.variant_for) {
        if (this.checkParentVariantName(product)) {
          return product.name.replace(`(${product.product.name})`, '')
        }
      }
      return product.name
    },
    checkParentVariantName(product) {
      return product.name.includes(`(${product.product.name})`)
    }
  }
}
</script>

<style scoped>
.order-title:hover {
  text-decoration: underline;
  cursor: pointer;
}
.border-bottom {
  border-bottom: 1px solid var(--v-basic300);
  border-radius: 0 !important;
}
</style>

<i18n>
{
  "en": {
    "matching": "Matching",
    "cod": "COD"
  },
  "id": {
    "matching": "Matching",
    "cod": "COD"
  }
}
</i18n>
